<!--
* @description  客户端头部
* @fileName  index
* @author userName
* @date 2023-12-24 11:13:36
!-->
<template>
  <div id="index" class="index">
    <div class="header">
      <div class="left flex flex-column-center">
        <a style="cursor: pointer;height: 64px;" @click="goToManage('/')">
          <el-image :src="config.logoIcon| toUrl()" style="height: 64px;">
            <template slot="error">
              <img src="@/assets/logo.png" height="64px">
            </template>
          </el-image>
        </a>
        <div class="title"><el-divider direction="vertical" />{{ $t('route.inquiry') }}</div>
      </div>
      <div class="right">
        <div>
          <el-dropdown @command="setLanguage">
            <button class="language">
              <i class="icon-ym icon-ym-language" style="font-size: 22px;" />
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :disabled="language==='zh'" command="zh">简体中文</el-dropdown-item>
              <el-dropdown-item :disabled="language==='zhtw'" command="zhtw">繁體中文</el-dropdown-item>
              <el-dropdown-item :disabled="language==='en'" command="en">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!--未登录-->
        <div v-if="!isLogin" class="login-button">
          <button class="by-common--primary" @click="signin">{{ $t('common.signin') }}</button>
          <button class="by-button--primary margin-left_16" @click="signup">{{ $t('common.signup') }}</button>
        </div>
        <!--已登录-->
        <div v-else class="logind" @mouseover="navTopAtv=true" @mouseleave="navTopAtv=false">
          <el-avatar :src="customerInfo.userIcon" size="small" @click="goToManage">
            {{ customerInfo.userName }}
          </el-avatar>
          <el-collapse-transition>
            <div v-show="navTopAtv" class="topTipBox-login">
              <div class="navBoxSub-login">
                <div class="navBoxSub-first">
                  <!-- <div class="navBoxSub-left"></div> -->
                  <div class="navBoxSub-right">
                    <div class="name">{{ customerInfo.userName }}</div>
                    <div class="customer">{{ customerInfo.customerName }}</div>
                    <div class="emil">{{ customerInfo.email }}</div>
                  </div>
                </div>
                <div class="line" />
                <div class="navBoxSub-two">
                  <div @click="goToManage('/shipments')">{{ $t('common.shipments') }}</div>
                  <!-- <div @click="goToManage()">Custom Quotes</div> -->
                  <div @click="goToManage('/billing')">{{ $t('common.billing') }}</div>
                </div>
                <div class="line" />
                <div class="navBoxSub-tree">
                  <div @click="goToManage('/accountDetails')">{{ $t('common.settings') }}</div>
                </div>
                <div class="line" />
                <div class="navBoxSub-four" @click="logout">{{ $t('common.logout') }}</div>
              </div>
            </div>
          </el-collapse-transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetCurrCustomer, Logout } from '@/api/user'
import {
  getToken, setToken,
  removeToken,
  getLanguage,
  getUser, setUser
} from '@/utils/auth'
import { getCookie } from '@/utils/cookiejs'
export default {
  name: 'Dtmstop',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      navTopAtv: false
    }
  },
  computed: {
    // 计算属性
    language() {
      return this.$store.getters.language || 'zh'
    },
    config() {
      const config = this.$store.getters.config || {}
	  console.log(config)
      window.document.title = config.sysName || 'DTMS'
      // console.log(config)
      return config
    },
    isLogin() {
      const islogin = !!this.$store.getters.token
      // console.log(islogin)
      return islogin
    },
    customerInfo() {
      const user = getUser() || {}
      console.log(user)
      return user
    }
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    // this.customerInfo = getUser() || {}
    this.$i18n.locale = getLanguage() || 'zh'
    var token = getCookie('token')
    if (token) this.getCustomer()
  },
  mounted() {
    // 页面进入时加载内容
    // console.log('mounted');
  },
  methods: {
    // 方法
    goToManage(path) {
      if (!path) path = `/manage`
      const nativeHref = this.$router.resolve({
        path: path
      })
      window.location.href = nativeHref.href
    },
    getCustomer() {
      GetCurrCustomer().then(res => {
        if (res.code === 200) {
          setUser(res.data)
        }
      })
    },
    setLanguage(lang) {
      // 设置语言
      this.$i18n.locale = lang
      this.$store.commit('user/SET_LANGUAGE', lang)
      window.location.reload()
    },
    signin() {
      // 显示登陆
      this.$store.commit('user/DIALOG_VISIBLE', true)
    },
    signup() {
      // 显示注册
      this.$store.commit('user/STARTED_VISIBLE', true)
    },
    logout() {
      Logout().then(res => {
        if (res.code === 200) {
          this.$store.commit('user/SET_TOKEN', '')
          setUser({})
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
	.index {
		.header {
			width: 1200px;
			height: 64px;
			text-align: center;
			margin: auto;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.right {
				display: flex;
				align-items: center;

				.language {
					display: flex;
					border: none;
					background-color: transparent;
					cursor: pointer;
					line-height: 30px;
					margin: 0px 10px;
				}

				.login-button {
					display: flex;
					margin-left: 24px;

					button:nth-of-type(1) {
						width: 88px;
						height: 32px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 14px;
						color: #3370ff;
						line-height: 22px;
						text-align: center;
						font-style: normal;
						background: rgba(255, 255, 255, 0);
						border-radius: 8px;
						border: 1px solid #3370ff;
						box-sizing: border-box;
					}

					button:nth-of-type(2) {
						width: 88px;
						height: 32px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 14px;
						color: #ffffff;
						line-height: 22px;
						text-align: center;
						font-style: normal;
						background: #3370ff;
						border-radius: 8px;
						box-sizing: border-box;
					}
				}

				.logind {
					height: 28px;

					.loginInfo {
						margin: 0px 10px;
					}

					&:hover {
						.topTipBox-login {
							display: block;
							overflow: visible !important;
						}
					}

					.topTipBox-login {
						display: block;
						position: absolute;
						z-index: 999;
						width: 240px;
						height: 306px;

						.navBoxSub-login {
							top: 8px;
							position: relative;
							left: -182px;
							background: #ffffff;
							box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
							border-radius: 8px;
							border: 1px solid rgba(221, 221, 221, 0.56);
							padding: 16px;
							text-align: left;

							.line {
								width: 208px;
								height: 1px;
								background: #eeeeee;
								text-align: center;
								margin: 8px 0;
							}

							.navBoxSub-first {
								display: flex;

								.navBoxSub-left {
									@extend .loginInfo;
									width: 40px;
									height: 40px;
									margin: 0 8px 0 0;
									font-size: 23px;
									line-height: 40px;
									text-align: center;
								}

								.navBoxSub-right {
									text-align: left;
									font-family: PingFangSC, PingFang SC;

									.name {
										font-size: 16px;
										font-weight: 500;
										color: #333333;
									}

									.customer {
										color: #a6a6a6;
										font-size: 14px;
									}

									.emil {
										font-size: 14px;
										font-weight: 400;
										color: #777777;
									}
								}
							}

							.navBoxSub-two,
							.navBoxSub-tree {
								font-size: 16px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								color: #333333;

								div {
									padding: 8px 0;
									cursor: pointer;
								}
							}

							.navBoxSub-four {
								font-size: 16px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								color: #777777;
								// padding: 8px;
								text-align: left;
								cursor: pointer;
							}
						}
					}
				}
			}

			.left {
				.title {
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #333333;
					line-height: 20px;
					text-align: left;
					font-style: normal;

					.el-divider--vertical {
					  margin: 0 12px 0 0;
					}
				}
			}
		}
	}
</style>
